<template>
    <SbsTooltip class="sbs-videolayer-subtitles-icon" v-bind="tooltipData" ref="subtitles">
        <div class="sbs-videolayer-subtitles-icon__icon-wrapper" @click="toggleSubtitles">
            <InlineSvg class="sbs-videolayer-subtitles-icon__icon" :src="subtitlesIcon" />
            <div class="sbs-videolayer-subtitles-icon__border" :class="{'sbs-videolayer-subtitles-icon__border--active': isActiveSub}"></div>
        </div>
    </SbsTooltip>
</template>

<script>
import { toRaw } from 'vue';
import InlineSvg from 'vue-inline-svg';
import SbsTooltip from '../../tooltip/SbsTooltip.vue';
import subtitlesIcon from '../../../assets/svg/subtitles-icon.svg';

export default {
    name: 'SbsVideoPlayerSubtitles',
    components: {
        SbsTooltip,
        InlineSvg,
    },
    inject: {
        videoPlayerComponent: { default: null },
    },
    data() {
        return {
            subtitlesIcon,
            isActiveSub: false,
        };
    },
    computed: {
        player() {
            return toRaw(this.videoPlayerComponent.player);
        },
        tooltipData() {
            return {
                parentSelector: this.videoPlayerComponent.videoContainerSelector,
                offset: 0,
                position: 'top',
                width: 90,
                content: 'Субтитры',
            };
        },
    },
    methods: {
        toggleSubtitles() {
            const textTracks = this.player.textTracks();

            if (!textTracks.length) {
                return;
            }

            const activeTrack = textTracks[0];

            if (activeTrack.mode === 'showing') {
                activeTrack.mode = 'hidden';
                this.isActiveSub = false;
            } else {
                activeTrack.mode = 'showing';
                this.isActiveSub = true;
            }
        },
        playerLoadedDataHandler() {
            if (this.player.textTracks().length) {
                const textTracks = this.player.textTracks();

                textTracks[0].mode = 'hidden';
                this.isActiveSub = textTracks[0].mode === 'showing';

            }
        },
        addListeners() {
            this.player.on('loadeddata', this.playerLoadedDataHandler);
        },
        removeListeners() {
            this.player.off('loadeddata', this.playerLoadedDataHandler);
        },
    },
    mounted() {
        this.player.controlBar.addChild('Component', {
            el: this.$refs.subtitles.$el,
        });
        this.addListeners();
    },
    beforeUnmount() {
        this.removeListeners();
    },
};
</script>

<style lang="scss">
@import "../styles/mixins.scss";

.hideSubtitle {
    display: none;
}

.vjs-subtitles-button.vjs-control {
    cursor: pointer;

    .vjs-control-bar & {
        width: 20px;
        margin-right: 10px;
        margin-left: 10px;
    }

    &.active .vjs-icon-placeholder::before {
        width: 22px;
        height: 36px;
        border-bottom: 2px solid var(--video-player-theme);
    }
}

.sbs-videolayer-subtitles-icon__icon-wrapper {
    flex-direction: column;
    padding-top: 3px;

    @include video-icon-wrapper;
}

.sbs-videolayer-subtitles-icon__border {
    width: 20px;
    height: 2px;
    background-color: transparent;
    border-radius: 50px;

    &--active {
        background-color: var(--video-player-theme);
    }
}

.sbs-videolayer-subtitles-icon__icon {
    margin-bottom: 2.5px;

    @include video-icon;
}
</style>
